module.exports = __webpack_public_path__ + "img/fire_two2.35eaf227.jpg";